import {
  //
  SET_GOAT,
  GOAT_API_REQUEST,
  GOAT_API_SUCCESS,
  GOAT_API_FAILURE,
} from '../actions/actionTypes';

const initialState = {
  loading: true,
  error: null,
  lat: null,
  lng: null,
};

export default function goat(state = initialState, action) {
  switch (action.type) {
    case SET_GOAT: {
      const { data } = action.payload;
      return {
        ...state,
        ...data,
      };
    }
    case GOAT_API_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GOAT_API_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case GOAT_API_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
